import React, { Component } from "react";
import config from "react-global-configuration";
import axios from "axios";
import $ from "jquery";
import Select from "react-select";
import jwt_decode from "jwt-decode";
import { style } from "variables/Variables.jsx";
import "../assets/css/react-confirm-alert/react-confirm-alert.css";
import NotificationSystem from "react-notification-system";
import { confirmAlert } from "react-confirm-alert";
import { BeatLoader } from "react-spinners";
import "../assets/css/monthpicker/month-picker.css";
import { css } from "@emotion/core";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import * as moment from "moment";
import { List } from "react-virtualized";
import ModalD from "react-awesome-modal";
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Switch from "react-switch";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import {
  isApiResponse,
  isReportAccess,
  date_range_config,
  reactSelectStyles,
  user_activities,
} from "helpers/utils.js";
import MultiCsvReportDownload from "components/DownloadReport/MultiCsvReportDownload.jsx";
import DatePicker from "react-datepicker";
const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config("30", "0", "2020-02-01", "0");
class BankBudgetReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
       _notificationSystem: null,
      datefrom: date_config.start_date,
      dateTo: date_config.end_date,
      datefromShow: date_config.display_start_date,
      dateToShow: date_config.display_end_date,
      yestSend: date_config.start_date_value,
      todSend: date_config.end_date_value,
      dateFromLimit: date_config.start_date_limit,
      dateLimit: date_config.end_date_limit,
      newBankModel: false,
      brand_render_list: [],
      selected_brand: "",
      selected_brand_code: "",
      brandValue: null,
      bank_options_render: [],
      selected_bank: "",
      selected_bank_code: "",
      bankValue: null,
      start_date: moment(new Date()).format("YYYY-MM-DD"),
      end_date: moment(new Date()).format("YYYY-MM-DD"),
      bank_allocated_amount: "",
    };
  }
  handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
  componentWillMount() {

        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        isReportAccess(AllAccessPermissions, "get_bank_budget");
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        let subMenuPermissions = [];
        let reportPermissions = [];
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });

        this.setState({
            reportPermissionsArray:reportPermissions,
            user_id:decoded._id
        });


        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
            email:decoded.email
        });


    }
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    var _notificationSystem = this.refs.notificationSystem;
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    var isDisableInput = false;
    if (decoded.userSubGroup === 5 && decoded.userSubGroupName === "IT") {
      isDisableInput = true;
    }
    this.setState({
      email: decoded.email,
      userSubGroup: decoded.userSubGroup,
      userSubGroupName: decoded.userSubGroupName,
      isDisableInput: isDisableInput,
    });
    this.getBrandList();
    this.getBankList();
    this.get_bank_budget();
  }
  onChangeInput(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  toggleNewBankModel(modal_type) {
    //this.clearForm();
    this.setState({
      newBankModel: !this.state.newBankModel,
      action_type: "Add Bank Budget",
    });
  }
  get_bank_budget() {
    var that = this;
    var a = moment(this.state.todSend);
    var b = moment(this.state.yestSend);

    var postData = {
      bank: this.state.bank_names,
      yestSend: this.state.yestSend,
      todSend: this.state.todSend,
      report_code: "get_bank_budget",
      user_id: this.state.user_id,
      merchant_names: this.state.merchant_names,
    };
    var BankBudgetTable = "";
    if ($.fn.DataTable.isDataTable("#BankBudgetTable")) {
      $("#BankBudgetTable").DataTable().clear().destroy();
    }

    BankBudgetTable = $("#BankBudgetTable").DataTable({
      order: [],
      //"dom": 'fltip',
      processing: true,
      serverSide: true,
      bDestroy: true,
      paging: true,
      pageLength: 20,
      bInfo: false,
      sPaginationType: "numbers",
      autoWidth: true,
      responsive: false,
      //"scrollX": true,
      searching: true,
      lengthMenu: [
        [20, 50, 100, 500 - 1],
        [20, 50, 100, 500, "All"],
      ],

      ajax: {
        url: config.get("API_URL") + "/InternalReport/get_bank_budget",
        type: "POST",
        data: postData,
        dataSrc: function (json) {
          isApiResponse(true);
          that.setState({
            isChange: false,
          });
          return json.data;
        },
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", localStorage.usertoken);
        },
        error: function (data) {
          isApiResponse(true);
          alert("Failed to load data. Please try again");
          console.log("error", data);
        },
        complete: function (data) {
          isApiResponse(true);
          console.log("complete", data);
        },
      },

      columns: [
        { data: "Bank" },
        { data: "Brand" },
        { data: "From Date" },
        { data: "To Date" },
        { data: "Allocated Amount" },
        { data: "id" },

      ],
      columnDefs: [
        {
          className: "text-center",
          targets: 5,
          data: "data",
          createdCell: (td, cellData, rowData, row, col) => {
            $(td).text("");
            $(td).append(
              '<a href="#" data-tip="Stop" title="View" id="edit" class="btn btn-default actionBtn btn-edit"><span class="glyphicon glyphicon-edit" aria-hidden="true"></span></a>&nbsp;',
            );
            $(td).append(
              '<a href="#" data-tip="Delete" title="Delete" id="Delete" class="btn btn-default actionBtn btn-edit"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span</span></a>&nbsp;',
            );
            $(td)
              .find("#edit")
              .click((e) => {
                e.preventDefault(); // Prevent default link behavior
                this.budget_edit(e, rowData);
              });

            $(td)
              .find("#Delete")
              .click((e) => {
                e.preventDefault(); // Prevent default link behavior
                this.budget_delete(e, rowData.id);
              });
          },
          bSortable: false,
        },
      ],
    });
  }
  getBrandList = () => {
    const token = localStorage.usertoken;
    axios
      .get(config.get("API_URL") + "/brandemi/findAllManufacturers", {
        headers: {
          Authorization: ` ${localStorage.usertoken}`,
        },
      })
      .then((response) => {
        console.log(response);
        let brand_render_list = [];

        response.data.map((values, index) => {
          brand_render_list.push({
            value: values.id,
            label: values.party_name,
          });
        });
        this.setState({
          brand_render_list: brand_render_list,
          loading: false,
        });
      });
  };
  getBankList() {
    axios
      .get(config.get("API_URL") + "/brandemi/findAllIssuerBanks", {
        headers: {
          Authorization: ` ${localStorage.usertoken}`,
        },
      })
      .then((response) => {
        console.log(response.data._embedded.issuerBanks);
        let bank_options_render = [];
        if (
          Array.isArray(response.data._embedded.issuerBanks) &&
          response.data._embedded.issuerBanks.length
        ) {
          response.data._embedded.issuerBanks.map((valuea, index) => {
            bank_options_render.push({
              value: valuea.innoIssuerBankCode,
              label: valuea.issuerBankDisplayName,
              //             value1: valuea.innoIssuerBankCode,
              //             value2: valuea.issuerDefaultCashbackFlag
            });
          });
          this.setState({
            bank_options_render: bank_options_render,
          });
        }
      });
  }
  updateBrand = (optionSelected) => {
    const selected_brand = optionSelected === null ? "" : optionSelected.label;
    const selected_brand_code =
      optionSelected === null ? "" : optionSelected.value;
    this.setState({
      selected_brand: selected_brand,
      selected_brand_code: selected_brand_code,
      brandValue: optionSelected,
    });
  };
  updateBankValues = (optionSelected) => {
    const selected_bank = optionSelected === null ? "" : optionSelected.label;
    const selected_bank_code =
      optionSelected === null ? "" : optionSelected.value;
    this.setState({
      selected_bank: selected_bank,
      selected_bank_code: selected_bank_code,
      bankValue: optionSelected,
    });
  };
  handleFromChange = (date) => {
    var start_date1 = moment(date).format("YYYY-MM-DD");
    //alert(start_date1);
    this.setState({
      start_date: start_date1,
    });
  };

  handleToChange = (date) => {
    var end_date2 = moment(date).format("YYYY-MM-DD");
    //alert(end_date2);
    this.setState({
      end_date: end_date2,
    });
  };
  budget_delete(e, id) {
  // Prevent default behavior
  e.preventDefault();

  // Show confirmation dialog
  confirmAlert({
    title: 'Confirm to delete',
    message: 'Are you sure you want to delete this budget allocation?',
    buttons: [
      {
        label: 'Yes',
        onClick: () => {
          // Show loading indicator if needed
          this.setState({ isDeleting: true });

          axios.post(
            config.get("API_URL") + "/InternalReport/delete-budget",
            { id: id },
            {
              headers: {
                Authorization: ` ${localStorage.usertoken}`,
              },
            }
          )
          .then((response) => {
            if (response.data.status === 'success') {
              this.handleNotificationClick("tr", 1, response.data.message);
              // Refresh the budget list after successful deletion
              this.get_bank_budget();
            } else {
              this.handleNotificationClick("tr", 3, response.data.message);
            }
          })
          .catch((err) => {
            const errorMsg = err.response?.data?.message || "Failed to delete budget allocation";
            this.handleNotificationClick("tr", 3, errorMsg);
          })
          .finally(() => {
            this.setState({ isDeleting: false });
          });
        }
      },
      {
        label: 'No',
        onClick: () => {}
      }
    ]
  });
}
  budget_edit(e, rowData) {
      var bankValue = {value:rowData["bank_code"], label:rowData["Bank"]}
      var brandValue = {value:rowData["brand_code"], label:rowData["Brand"]}
      var to_date = rowData["To Date"]
      console.log(bankValue);
      console.log()
      console.log(rowData);
      const start_date = moment(rowData["From Date"], "DD-MM-YYYY").format("YYYY-MM-DD");
      const end_date = moment(rowData["To Date"], "DD-MM-YYYY").format("YYYY-MM-DD");

      this.setState({
        id:rowData.id,
        bankValue:bankValue,
        selected_bank: rowData["Bank"],
        selected_bank_code:rowData["bank_code"],
        brandValue: brandValue,
        selected_brand: rowData["Brand"],
        selected_brand_code: rowData["brand_code"],
        bank_allocated_amount: rowData["Allocated Amount"],
        start_date: rowData["From Date"],
        end_date:rowData["To Date"],
        newBankModel: !this.state.newBankModel,
        action_type: 'Edit Bank Budget',
      })

  }
  addBudget() {
    if (this.state.selected_bank === "") {
      this.handleNotificationClick("tr", 3, "Please Select Bank");
      return false;
    }
    if (this.state.selected_brand === "") {
      this.handleNotificationClick("tr", 3, "Please Select Brand");
      return false;
    }

    if(this.state.start_date=='') {
        this.handleNotificationClick("tr", 3, "Please Select Start Date");
        return false;
    }
    if(this.state.end_date=='') {
        this.handleNotificationClick("tr", 3, "Please Select End Date");
        return false;
    }
  if (this.state.bank_allocated_amount === "") {
      this.handleNotificationClick("tr", 3, "Please Enter bank allocated amount");
      return false;
    }
    var date1 = this.state.start_date;
    var date2 = this.state.end_date;
    var time1 = moment(date1).format('YYYY-MM-DD');
    var time2 = moment(date2).format('YYYY-MM-DD');
    if(time2 < time1){
        this.handleNotificationClick("tr", 3, "To date must be greater than or equal From date");
        return false;
    }
    const amountRegex = /^[0-9,.]+$/;
    if (!amountRegex.test(this.state.bank_allocated_amount)) {
      this.handleNotificationClick("tr", 3, "Amount should contain only numbers");
      return false;
    }
    const numericAmount = parseFloat(this.state.bank_allocated_amount.replace(/,/g, ''));
    axios
      .post(
        config.get("API_URL") + "/InternalReport/add-new-budget/",
        {
          selected_brand: this.state.selected_brand,
          selected_brand_code: this.state.selected_brand_code,
          selected_bank: this.state.selected_bank,
          selected_bank_code: this.state.selected_bank_code,
          start_date: this.state.start_date,
          end_date: this.state.end_date,
          bank_allocated_amount: numericAmount,
          email: this.state.email
        },
        {
          headers: {
            Authorization: ` ${localStorage.usertoken}`,
          },
        },
      )
      .then((response) => { console.log(response)
        if (response.data.status === "success") {

        this.handleNotificationClick("tr", 1, response.data.message);
      } else {

        this.handleNotificationClick("tr", 3, response.data.message);
      }
        this.get_bank_budget();
      })
      .catch((err) => {
        let errorMsg =
        err.response?.data?.message || "Something went wrong. Please try again.";

      this.handleNotificationClick("tr", 3, { message: errorMsg });
      });
    this.setState({
      newBankModel: false,
    });
  }
  updateBudget() {
    // Validation checks (same as addBudget)
    if (this.state.selected_bank === "") {
      this.handleNotificationClick("tr", 3, "Please Select Bank");
      return false;
    }
    if (this.state.selected_brand === "") {
      this.handleNotificationClick("tr", 3, "Please Select Brand");
      return false;
    }
    if(this.state.start_date=='') {
        this.handleNotificationClick("tr", 3, "Please Select Start Date");
        return false;
    }
    if(this.state.end_date=='') {
        this.handleNotificationClick("tr", 3, "Please Select End Date");
        return false;
    }
    if (this.state.bank_allocated_amount === "") {
      this.handleNotificationClick("tr", 3, "Please Enter bank allocated amount");
      return false;
    }

    // Date validation
    var date1 = this.state.start_date;
    var date2 = this.state.end_date;
    var time1 = moment(date1).format('YYYY-MM-DD');
    var time2 = moment(date2).format('YYYY-MM-DD');
    if(time2 < time1){
        this.handleNotificationClick("tr", 3, "To date must be greater than or equal From date");
        return false;
    }

    // Amount validation
    const amountRegex = /^[0-9,.]+$/;
    if (!amountRegex.test(this.state.bank_allocated_amount)) {
      this.handleNotificationClick("tr", 3, "Amount should contain only numbers");
      return false;
    }

    // Convert to number (remove commas)
    const numericAmount = parseFloat(this.state.bank_allocated_amount.replace(/,/g, ''));
    if (isNaN(numericAmount)) {
      this.handleNotificationClick("tr", 3, "Please enter a valid amount");
      return false;
    }
    if (numericAmount <= 0) {
      this.handleNotificationClick("tr", 3, "Amount must be greater than zero");
      return false;
    }

    axios
      .post(
        config.get("API_URL") + "/InternalReport/edit-budget",
        {
          id: this.state.id,
          selected_brand: this.state.selected_brand,
          selected_brand_code: this.state.selected_brand_code,
          selected_bank: this.state.selected_bank,
          selected_bank_code: this.state.selected_bank_code,
          start_date: this.state.start_date,
          end_date: this.state.end_date,
          bank_allocated_amount: numericAmount,
          email: this.state.email
        },
        {
          headers: {
            Authorization: ` ${localStorage.usertoken}`,
          },
        },
      )
      .then((response) => {
        console.log(response);
        if (response.data.status === "success") {
          this.handleNotificationClick("tr", 1, response.data.message);
           // Refresh the data
        } else {
          this.handleNotificationClick("tr", 3, response.data.message);
        }
        this.get_bank_budget();
      })
      .catch((err) => {
        let errorMsg = err.response?.data?.message || "Something went wrong. Please try again.";
        this.handleNotificationClick("tr", 3, { message: errorMsg });
      });

    this.setState({
      newBankModel: false,
    });
  }
  downLoadPcReport (e){
        let filters = {
            start_date: '2025-07-01',
            end_date: '2025-07-01',
            bank: this.state.bank_names,
              report_code: "get_bank_budget",
              user_id: this.state.user_id,
            download: 1,
        }
        this.setState({
            filters:filters
        })
        this.refs.downloadAllReport.downLoadReport(filters, '/internal_reports/bank-brand-budget-report','bank_budget','');
    }
  render() {
    return (
      <div className="content">
        <NotificationSystem ref="notificationSystem" style={style} />
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 pt-5">

              <div className="card">
                <div className="content table-full-width table-responsive nomargin">
                  <div className="col-md-8">
                    <div className="">
                      <h4 className="title">Bank Budget Report</h4>
                    </div>
                  </div>
                  {this.state.userSubGroup !== 5 &&
                  this.state.userSubGroupName !== "IT" ? (
                    <div
                      className="col-md-4 pull-right"
                      style={{ textAlign: "right" }}
                    >
                      <a
                        href="#"
                        className="addButton"
                        role="button"
                        onClick={this.toggleNewBankModel.bind(this, "Add")}
                      >
                        <span
                          className="glyphicon glyphicon-plus"
                          aria-hidden="true"
                        ></span>
                        Add Bank Budget
                      </a>
                    </div>
                  ) : null}
                  <div className="clearfix"></div>
                  <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downLoadPcReport.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>

                                    <div className="content-tdetails-table table-full-width marginTop0">
                  <table
                    id="BankBudgetTable"
                    className="table table-striped table-hover"
                  >
                    <thead>
                      <tr>
                        <th>Bank</th>
                        <th>Brand</th>
                        <th>From Date</th>
                        <th>To date</th>
                        <th>Allocated Amount</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                  </div>
                  <style>
                    {`
  .custom-modal-width {
    max-width: 300px;  /* You can change to 400px or any other width */
    margin: auto;
  }
`}
                  </style>
                  <Modal
                    isOpen={this.state.newBankModel}
                    toggle={this.toggleNewBankModel.bind(this)}
                    contentClassName="custom-modal-width"
                  >
                    <ModalHeader toggle={this.toggleNewBankModel.bind(this)}>
                      {this.state.action_type}
                    </ModalHeader>
                    <ModalBody className="user_form_fields">
                      <div className="row">
                        <div className="col-md-12 col-xs-12">
                          <FormGroup>
                            <Label for="taskName">Bank Name</Label>
                            <Select
                              name={"bank_name"}
                              value={this.state.bankValue}
                              styles={reactSelectStyles}
                              className="report-listbox"
                              onChange={this.updateBankValues.bind(this)}
                              options={this.state.bank_options_render}
                              placeholder="Select bank"
                              isClearable={true}
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-12 col-sm-12">
                          <FormGroup>
                            <Label>Select Brand</Label>
                            <Select
                              name="brand_name"
                              value={this.state.brandValue}
                              styles={reactSelectStyles}
                              className="report-listbox"
                              onChange={this.updateBrand.bind(this)}
                              options={this.state.brand_render_list}
                              placeholder="Select Brand"
                            />
                          </FormGroup>
                        </div>

                        <div className="col-md-12 col-sm-12">
                          <FormGroup>
                            <Label for="FromDate">From Date</Label>
                            <DatePicker
                              dateFormat="d MMM yyyy"
                              selected={Date.parse(this.state.start_date)}
                              onChange={this.handleFromChange}
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-12 col-sm-12">
                          <Label for="FromDate">To Date</Label>
                          <DatePicker
                            dateFormat="d MMM yyyy"
                            selected={Date.parse(this.state.end_date)}
                            onChange={this.handleToChange}
                          />
                        </div>
                        <div className="col-md-12 col-sm-12">
                          <Label for="FromDate">Bank Allocated Amount</Label>
                          <Input
                            id="bank_allocated_amount"
                            name="bank_allocated_amount"
                            value={this.state.bank_allocated_amount}
                            onChange={this.onChangeInput.bind(this)}
                          />
                        </div>
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <div className="col-md-12 pull-right">
                        {this.state.action_type == "Add Bank Budget" ? (
                          <Button
                            color="primary"
                            onClick={this.addBudget.bind(this)}
                          >
                            Submit
                          </Button>
                        ) : null}
                        {this.state.action_type == "Edit Bank Budget" ? (
                          <React.Fragment>
                            <Button
                              color="primary"
                              onClick={this.updateBudget.bind(this, "")}
                            >
                              Edit
                            </Button>
                            &nbsp;&nbsp;
                          </React.Fragment>
                        ) : null}

                        <Button
                          color="secondary"
                          onClick={this.toggleNewBankModel.bind(this)}
                        >
                          Cancel
                        </Button>
                      </div>
                    </ModalFooter>
                  </Modal>
                </div>
                <MultiCsvReportDownload ref="downloadAllReport" />
                <div className="footer">
                  <div className="stats">
                    <i></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BankBudgetReport;
